<script lang="ts" setup>
import { onUnmounted, watch } from "vue";
import { useBaseView } from "@/composables";

const { handleSiteScrollDisable } = useBaseView();

const model = defineModel<boolean>({ default: false });

watch(
  model,
  (value) => {
    handleSiteScrollDisable(value);
  },
  {
    immediate: true,
  },
);

onUnmounted(() => {
  handleSiteScrollDisable(false);
});
</script>

<template>
  <div>
    <teleport to="body">
      <transition name="fade">
        <div v-if="model" class="omni-overlay">
          <div class="omni-overlay__header">
            <slot name="header"></slot>
            <div class="omni-overlay__close" @click="model = false">
              <v-icon color="white" size="32">mdi-close</v-icon>
            </div>
          </div>
          <div class="omni-overlay__content">
            <slot></slot>
          </div>
          <div class="omni-overlay__footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </transition>
    </teleport>
  </div>
</template>

<style lang="scss" scoped>
.omni-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(30, 30, 30, 0.9);
  z-index: 1999;
  padding: 26px;
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    align-items: center;
  }

  &__close {
    width: 96px;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    transition:
      color 150ms ease-in-out,
      background-color 150ms ease-in-out;
    cursor: pointer;

    &:hover {
      background: rgba(30, 30, 30, 0.6);
    }
  }

  &__content {
    margin-top: 32px;
    flex: 1;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
